import { render, staticRenderFns } from "./expireDateItems.vue?vue&type=template&id=1b29f3ba&scoped=true&"
import script from "./expireDateItems.vue?vue&type=script&lang=js&"
export * from "./expireDateItems.vue?vue&type=script&lang=js&"
import style0 from "./expireDateItems.vue?vue&type=style&index=0&id=1b29f3ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b29f3ba",
  null
  
)

export default component.exports